var _circle, _path, _path2, _path3, _circle2, _path4, _path5, _path6, _circle3, _path7, _path8, _path9, _circle4, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 56,
    viewBox: "0 0 116 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 51,
    r: 5,
    fill: "#E6DE00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.832 51.815H1L7.59087 27.8676H13.2412L19.832 51.815Z",
    fill: "#F8F9FB",
    stroke: "#918D8A",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3258 18.3763H7.50659V27.8682H13.3258V18.3763Z",
    fill: "#F8F9FB",
    stroke: "#918D8A",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4163 18.2892V0",
    stroke: "#918D8A",
    strokeMiterlimit: 10
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.832,
    cy: 51,
    r: 5,
    fill: "#E6DE00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6641 51.815H32.832L39.4229 27.8676H45.0732L51.6641 51.815Z",
    fill: "#F8F9FB",
    stroke: "#918D8A",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1578 18.3763H39.3386V27.8682H45.1578V18.3763Z",
    fill: "#F8F9FB",
    stroke: "#918D8A",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2483 18.2892V0",
    stroke: "#918D8A",
    strokeMiterlimit: 10
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.6641,
    cy: 51,
    r: 5,
    fill: "#E6DE00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4961 51.815H64.6641L71.2549 27.8676H76.9052L83.4961 51.815Z",
    fill: "#F8F9FB",
    stroke: "#918D8A",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9899 18.3763H71.1707V27.8682H76.9899V18.3763Z",
    fill: "#F8F9FB",
    stroke: "#918D8A",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0803 18.2892V0",
    stroke: "#918D8A",
    strokeMiterlimit: 10
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 105.496,
    cy: 51,
    r: 5,
    fill: "#E6DE00"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M115.328 51.815H96.4961L103.087 27.8676H108.737L115.328 51.815Z",
    fill: "#F8F9FB",
    stroke: "#918D8A",
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M108.822 18.3763H103.003V27.8682H108.822V18.3763Z",
    fill: "#F8F9FB",
    stroke: "#918D8A",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M105.912 18.2892V0",
    stroke: "#918D8A",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.ca0fcef16c64d45de3c3bcdf49e21604.svg";
export { ForwardRef as ReactComponent };